import { useEffect, useRef, useState } from 'react';
import { useAuthStore } from '@/stores/authStore';

export interface LeadStateUpdate {
  state_id: string;
  contact_id: string;
  new_state: string;
  campaign_id?: string;
  timestamp: string;
}

export function useLeadsStream(workspaceId: string | undefined, campaignId?: string) {
  const [updates, setUpdates] = useState<LeadStateUpdate[]>([]);
  const token = useAuthStore((s) => s.token);

  const campaignIdRef = useRef(campaignId);
  campaignIdRef.current = campaignId;

  useEffect(() => {
    if (!workspaceId || !token) return;

    const params = new URLSearchParams({
      workspace_id: workspaceId,
      token,
      ...(campaignId ? { campaign_id: campaignId } : {}),
    });

    const es = new EventSource(`/v1/leads/stream?${params}`);

    es.addEventListener('lead_state_changed', (e: MessageEvent) => {
      try {
        const update = JSON.parse(e.data) as LeadStateUpdate;
        setUpdates((prev) => [...prev.slice(-99), update]);
      } catch {
        // ignore malformed
      }
    });

    es.onerror = () => {
      es.close();
    };

    return () => {
      es.close();
    };
  }, [workspaceId, token, campaignId]);

  return updates;
}
